/** Icons8 clapping hands - pale = default, yellow = engaged. */
export const CLAP_ICON_DEFAULT = '/schools/parashari/assets/icons8-clapping-hands-default.png';
export const CLAP_ICON_ACTIVE = '/schools/parashari/assets/icons8-clapping-hands-active.png';
